import { selector } from "recoil";
import tableState from "./state";

const MAX_ERRORS = 10;

export const tableErrorsSelector = selector({
  key: "tableErrorsSelector",
  get: ({ get }) => {
    const state = get(tableState);
    let newState = {};
    Object.entries(state).forEach((error) => {
      const [key, values] = error;
      const valueSet = Object.entries(values);
      let totalErrors = 0;
      valueSet.every((error) => {
        if (totalErrors >= MAX_ERRORS) {
          newState[key].push(`Please resolve errors for additional rows.`);
          return false;
        }
        const [subKey, subValues] = error;
        if (subValues.length) {
          totalErrors++;
          let otherErrors = newState[key] ? newState[key] : [];
          newState[key] = [
            ...otherErrors,
            `Please resolve errors on row #${1 + parseInt(subKey)}`,
          ];
        }
        return true;
      });
    });
    return newState;
  },
});

export const tableRowsErrorsSelector = selector({
  key: "tableRowsErrorsSelector",
  get: ({ get }) => {
    const state = get(tableState);
    let newState = {};
    Object.entries(state).forEach((error) => {
      const [key, values] = error;

      Object.entries(values).forEach((error) => {
        const [subKey, subValues] = error;

        if (subValues.length) {
          let preValues = newState[`${key}`] ? newState[`${key}`] : [];
          newState = { ...newState, [`${key}`]: [...preValues, subKey] };
        }
      });
    });

    return newState;
  },
});
export const tableValidSelector = selector({
  key: "tableValidSelector",
  get: ({ get }) => {
    const state = get(tableErrorsSelector);
    return Object.keys(state).length === 0;
  },
});

/**
 * Had to duplicate code here. This is because 9089 and 9142C both have the same machine name 'appx_b' for the recoil table
 * and the object can not reference two values of the same property. Not only that, we can not turn the selector into a function
 * becaues useRecoilValue requires either a selector or an atom so there is no way to pass a value down to be easily used.
 */
export const tablePageErrorSelector_9142B_9089 = selector({
  key: "tablePageErrorSelector_9142B_9089",
  get: ({ get }) => {
    const state = get(tableErrorsSelector);
    const pageErrors = Object.keys(state).map((machine_name) => {
      return machineNameToPageNumberLookup_9142B_9089[machine_name] ?? 12;
    });
    return pageErrors;
  },
});
const machineNameToPageNumberLookup_9142B_9089 = {
  //9142B
  employmentLocations: 12,
  //9089
  appx_b: 20,
};

export const tablePageErrorSelector_9142C = selector({
  key: "tablePageErrorSelector_9142C",
  get: ({ get }) => {
    const state = get(tableErrorsSelector);
    const pageErrors = Object.keys(state).map((machine_name) => {
      return machineNameToPageNumberLookup_9142C[machine_name] || null;
    });
    return pageErrors;
  },
});
const machineNameToPageNumberLookup_9142C = {
  appx_b: 12,
};
